<template>
    <v-list>
        <profile-list-item v-for="(item, index) in items" :key="index" v-bind="item" />
    </v-list>
</template>

<script setup lang="ts">
import ProfileListItem from './ProfileItem.vue';
import { ProfileItem } from '@/features/Profile/container/Profile.vue';

interface Props {
    items: Array<ProfileItem>;
}

defineProps<Props>();
</script>
